import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();

export const getSpeechConfig = createAsyncThunk(
  "speechConfig/getSpeechConfig",
  async (mail, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${baseUrl}/azure_speech_config`, {
        headers: {
          "Content-Type": "application/json",
          "use-case": "src",
          ...getAuthApiHeaders(),
          client: "UT",
        },
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);

const speechConfigSlice = createSlice({
  name: "speech-config",
  initialState: {
    isLoading: false,
    speechConfig: "",
    isError: false,
    error: null,
    success: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getSpeechConfig.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getSpeechConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.speechConfig = action.payload;
      state.success = true;
    });
    builder.addCase(getSpeechConfig.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      state.success = false;
    });
  },
});

export default speechConfigSlice.reducer;
